import React from "react";
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import AuthenticateView from "./view/authenticate/AuthenticateView";
import ForgotPasswordView from "./view/forgotpassword/ForgotPasswordView";
import EnterNewPasswordView from "./view/forgotpassword/EnterNewPasswordView";
import SetPasswordView from "./view/confirmuser/SetPasswordView";
import {LxPageNotFound} from "@lxo-blocks/react/Pages/NotFound/PageNotFound";
import {LxPageErrorBoundary} from "@lxo-blocks/react/Pages/ErrorBoundary/PageErrorBoundary";
import {Box, CircularProgress} from "@mui/material";

export default function AppRoute(): JSX.Element {
    return (
        <LxPageErrorBoundary>
            <React.Suspense fallback={<SuspenseLoading/>}>
                <BrowserRouter basename={"sign-in"}>
                    <Routes>
                        <Route path="/" element={<Navigate to={"/authenticate" + window.location.search}/>}/>
                        <Route path={"/authenticate/:userName?"} element={<AuthenticateView/>}/>
                        <Route path={"/forgot-password"} element={<ForgotPasswordView/>}/>
                        <Route path={"/new-password/:confirmationTicketId"} element={<EnterNewPasswordView/>}/>
                        <Route path={"/set-password/:confirmationTicketId"} element={<SetPasswordView/>}/>
                        <Route path="*" element={<LxPageNotFound/>}/>
                    </Routes>
                </BrowserRouter>
            </React.Suspense>
        </LxPageErrorBoundary>
    );
}


const SuspenseLoading = () => {
    return (
        <Box sx={{mt: 5, pt: 5}} style={{display: 'flex', justifyContent: 'center'}}>
            <CircularProgress/>
        </Box>
    );
}
